import { required } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
import PropertyFileType from '@/services/Property/PropertyFileType';
import PropertyFileTypes from '@/services/Property/PropertyFileTypes';

const propertyFileTypesHiddenDates = [
  PropertyFileTypes.EXTERNAL_WALL_SURVEY,
];

export const form = () => cloneDeep({
  propertyFileTypeId: {
    label: 'File Type',
    type: 'select',
    value: '',
    trackBy: 'propertyFileTypeId',
    labelBy: 'type',
    options: [],
    optionsFn: async () => {
      const { data } = await PropertyFileType.list();
      const types = data.data;

      // Push an empty option so the user can unset the current type
      types.push({
        deleted: 0,
        hasExpiryDate: 0,
        hasIssueDate: 0,
        propertyFileTypeId: '',
        type: ' ',
      });

      // Alphabetically sort the list of options
      types.sort((a, b) => {
        if (a.type < b.type) { return -1; }
        if (a.type > b.type) { return 1; }

        return 0;
      });

      return types;
    },
  },
  expiryDate: {
    label: 'RA Expiry Date',
    type: 'date',
    value: '',
    hidden: passedForm => (passedForm.propertyFileTypeId.value
      ? propertyFileTypesHiddenDates.includes(passedForm.propertyFileTypeId.value.type)
      : true),
  },
  issueDate: {
    label: 'Issue Date',
    type: 'date',
    value: '',
    hidden: passedForm => (passedForm.propertyFileTypeId.value
      ? propertyFileTypesHiddenDates.includes(passedForm.propertyFileTypeId.value.type)
      : true),
  },
});

export const validators = {
  propertyFileTypeId: {
    required,
  },
  expiryDate: {
    required,
  },
  issueDate: {
    required,
  },
};
